import NewLogin from './new-login.vue'

export default NewLogin
